// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"8c102996","296":"c77b9739","536":"6a55b1e2","700":"a90359f2"}[chunkId] + ".chunk.js";
};